import classNames from 'classnames'

import { MissionLabel, MissionLabelType } from '@web/gql/graphql'

import styles from '../MissionCard.module.scss'

interface Props {
  label: MissionLabel
}

const Label = ({ label }: Props) => {
  const isBonus = label?.type == MissionLabelType.Bonus
  const isNew = label?.type == MissionLabelType.New

  return (
    <span className={classNames(styles.label, { [styles.type_bonus]: isBonus, [styles.type_new]: isNew })}>
      {label.text}
    </span>
  )
}

export default Label
